import { Card, CardContent, Stack, Typography } from "@mui/material";
import React from "react";

// Card wrapper for the single pet view's tabs, matching the Overview tab's cards
export default function PetTabSection({ icon, title, children }) {
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
          {icon &&
            React.cloneElement(icon, {
              color: "primary",
              sx: { fontSize: 28 },
            })}
          <Typography variant="h5" fontWeight={700}>
            {title}
          </Typography>
        </Stack>
        {children}
      </CardContent>
    </Card>
  );
}
